import { createI18n } from "vue-i18n";
import deCH from "@/locales/de-CH";
import frFR from "@/locales/fr-FR";
import enGB from "@/locales/en-GB";
import itCH from "@/locales/it-CH";

export const supportedLocales = ["de-CH", "fr-FR", "en-GB", "it-CH"] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

const defaultLocale: SupportedLocale = "de-CH";

export function isSupportedLocale(value: string | null | undefined): value is SupportedLocale {
	return !!value && (supportedLocales as readonly string[]).includes(value);
}

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale: defaultLocale,
	fallbackLocale: defaultLocale,
	messages: {
		"de-CH": deCH,
		"fr-FR": frFR,
		"en-GB": enGB,
		"it-CH": itCH,
	},
});

/**
 * Switches the active UI locale. Called once from Home.vue with the language passed in the
 * URL by the Kundenportal iframe host (defaults to German if none/invalid is given).
 */
export function setLocale(locale: string) {
	if (!isSupportedLocale(locale)) {
		return;
	}
	i18n.global.locale.value = locale;
}

export default i18n;
